import React, { useEffect } from 'react';
// import '../styles/BookingsPage.css';

export const SettingsPage: React.FC = () => {
  useEffect(() => {
    // TODO: Fetch bookings from API
    // Example: GET /api/bookings
  }, []);

  return (
    <div className="bookings-page">
      <div className="page-header">
        <h1>Settings</h1>
      </div>

    </div>
  );
};
